import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SidebarService {
  public readonly mobileOpen = signal(false);

  public open(): void { this.mobileOpen.set(true); }
  public close(): void { this.mobileOpen.set(false); }
  public toggle(): void { this.mobileOpen.update(v => !v); }
}
